import { FC } from "react"
import { FilesUpload } from "../../../../module/settings/containers/files/upload"

export const FilesUploadPage: FC = () => <FilesUpload />
